import { render, staticRenderFns } from "./CardTabs.vue?vue&type=template&id=37e06e2c&scoped=true"
import script from "./CardTabs.vue?vue&type=script&lang=js"
export * from "./CardTabs.vue?vue&type=script&lang=js"
import style0 from "./CardTabs.vue?vue&type=style&index=0&id=37e06e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e06e2c",
  null
  
)

export default component.exports